/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputBehaviorComponent extends React.Component {
    render() {
        let constants = this.props.app.config.constants,
            FirstPullOptions = null,
            action = '',
            postFlag = (this.props.input && this.props.input.postFlag) ? this.props.input.postFlag : 0,
            firstPullOptions = [],
            behaviorOptions = [
                {value: constants.POST_NOW, label: 'Post Immediately'},
                {value: constants.POST_QUEUE, label: 'Add to queue and post later'}
            ],
            styledSelectClass = "large";

        if (parseInt(this.props.input.postFlag) === constants.POST_NOW) {
            action = 'Post';
        } else {
            action = 'Queue';
        }

        firstPullOptions = [
            {value: constants.FIRSTPULL_SINGLE, label: 'The most recent item'},
            {value: constants.FIRSTPULL_OFF, label: 'The next new item published'},
            {value: constants.FIRSTPULL_ON, label: 'The most recent 10 items now'},
        ];

        if (this.props.styledSelectClass !== undefined && this.props.styledSelectClass) {
            styledSelectClass = this.props.styledSelectClass;
        }

        if (this.props.showFirstPull) {
            FirstPullOptions = (
                <fieldset>
                    <legend>What item should we post first?</legend>
                    <StyledSelect
                        options={firstPullOptions}
                        linkedField={this.props.statePath + ".firstPullFlag"}
                        value={this.props.input.firstPullFlag}
                        selectClass={styledSelectClass}
                        onChange={this.props.changeHandler}/>
                </fieldset>
            );
        }

        return (
            <div>
                {FirstPullOptions}
                <fieldset>
                    <legend>When should we post new items?</legend>
                    <StyledSelect
                        options={behaviorOptions}
                        linkedField={this.props.statePath + ".postFlag"}
                        value={postFlag}
                        selectClass={styledSelectClass}
                        onChange={this.props.changeHandler}/>
                </fieldset>
                
            </div>
        );
    }

};

InputBehaviorComponent.displayName = "InputBehaviorComponent";

InputBehaviorComponent.propTypes = {
    input: PropTypes.object,
    changeHandler: PropTypes.func,
    statePath: PropTypes.string,
    showFirstPull: PropTypes.bool
};

InputBehaviorComponent.defaultProps = {
    input: {},
    changeHandler: null,
    statePath: 'input',
    showFirstPull: true
};

export default ComponentWithContext(InputBehaviorComponent);
